import { useState } from "react";
import { useDispatch } from "react-redux";
import { request } from "@/Api";
import { FilesStore } from "@/common/FilesUploader";
import { setError } from "@/nav/navSlice";
import CustomBidImportWizard from "./CustomBidImportWizard";

export default function useCustomBidImport({
    projectId,
    onImportBidSuccess,
    onImportBidFailed,
    onCancel,
}) {
    const dispatch = useDispatch();
    const [step, setStep] = useState("UPLOAD");
    const [file, setFile] = useState(null);
    const [previewData, setPreviewData] = useState(null);

    const handleFilesTransfer = (files) => {
        const selectedFile = files[0];
        if (!selectedFile) return;
        setFile(selectedFile);
        setStep("LOADING_PREVIEW");

        const formData = new FormData();
        formData.append("sheet_file", selectedFile);

        request
            .post("/bids/custom-excel-preview", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                setPreviewData(response.data);
                setStep("MAPPING");
            })
            .catch((error) => {
                console.error("Preview failed:", error);
                dispatch(
                    setError({
                        message: `Failed to read Excel preview: ${error.response?.data?.detail || error.message}`,
                    }),
                );
                setStep("UPLOAD");
                setFile(null);
            });
    };

    const handleImportSubmit = (mappingConfig) => {
        setStep("IMPORTING");
        const formData = new FormData();
        formData.append("sheet_file", file);
        formData.append("project_id", projectId || "null");
        formData.append("mapping_config", JSON.stringify(mappingConfig));

        request
            .post("/bids/custom-excel-import", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                const bid = response.data;
                setStep("DONE");
                onImportBidSuccess && onImportBidSuccess(bid);
            })
            .catch((error) => {
                console.error("Custom import failed:", error);
                dispatch(
                    setError({
                        message: `Problem importing custom bid: ${error.response?.data?.detail || error.message}`,
                    }),
                );
                onImportBidFailed && onImportBidFailed(error);
                setStep("MAPPING");
            });
    };

    let importUI = null;
    if (step === "UPLOAD" || step === "LOADING_PREVIEW") {
        importUI = (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                }}
            >
                <div style={{ width: "100%", height: "60%" }}>
                    <FilesStore
                        innerTitle={
                            step === "LOADING_PREVIEW"
                                ? "Loading Preview..."
                                : "Drag and drop any client excel file for Smart Import"
                        }
                        filesData={file ? [file] : []}
                        single={true}
                        acceptedFormats={[".xlsx", ".xls"]}
                        onFilesTransfer={handleFilesTransfer}
                        disabled={step === "LOADING_PREVIEW"}
                    />
                </div>
            </div>
        );
    } else if (step === "MAPPING" || step === "IMPORTING") {
        importUI = (
            <CustomBidImportWizard
                previewData={previewData}
                onPrimarySubmit={handleImportSubmit}
                primarySubmitText="Run Smart Import"
                onCancel={onCancel}
                isImporting={step === "IMPORTING"}
            />
        );
    }

    return { importUI };
}
